import useAuthStore from '../store/authStore';
import useTranslations from './useTranslation';

const useAdminMobileRestriction = () => {
  const { is_admin_login_mobile, user } = useAuthStore(state => state);
  const {translate} = useTranslations();

  
  // Check if user is admin (not superadmin) and logged in via mobile
  const isAdminMobileRestricted = is_admin_login_mobile && user?.user_role === 'ADMIN';
  
  return {
    isAdminMobileRestricted,
    message: translate('Oops! You must login on a desktop browser to access administrative features.')
  };
};

export default useAdminMobileRestriction;
